<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"

	[value]="avisInitial.idWeb"

	[label]="'idWeb'"
	[type]="'text'"
	[rule]="'pattern_9|required'"
	[errorMessage]="{'pattern' : 'ctr_pattern9'}"
	[name]="getUid() + '_SepAtt_idWeb'"
>
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="avisInitial.datePublication"

[label]="'datePublication'"
[type]="'text'"
[rule]=""
[name]="getUid() + '_SepAtt_datePublication'">
</app-form-input>
